export const parseAiResponse = (raw, fallback = {}) => {
  if (!raw) return fallback;
  if (typeof raw === "object") return raw;
  if (typeof raw !== "string") return fallback;

  try {
    return JSON.parse(raw);
  } catch (error) {
    return fallback;
  }
};

export const getEssayScoreDefaults = (score = {}) => ({
  total_score: 0,
  content_score: 0,
  grammar_score: 0,
  vocab_range_score: 0,
  spelling_score: 0,
  form_score: 0,
  general_linguistic_range_score: 0,
  development_structure_coherence_score: 0,
  comments: {},
  temp_mistakes: { mistakes: [] },
  "corrected words": {},
  mistakes: [],
  ...score,
  comments: score?.comments || {},
  temp_mistakes: score?.temp_mistakes || { mistakes: [] },
  "corrected words": score?.["corrected words"] || {},
  mistakes: Array.isArray(score?.mistakes) ? score.mistakes : [],
});

export const parseEssayAiResponse = (raw) =>
  getEssayScoreDefaults(parseAiResponse(raw, {}));

export const asScoreNumber = (value) => {
  const score = Number(value);
  return Number.isFinite(score) ? score : 0;
};
